/**
 * Whether an async-model call actually succeeded.
 *
 * `run()` resolves `undefined` when the request fails, so `resp?.isSuccessful === false` is never
 * true and every guard written that way is dead code. Some endpoints also return void on success,
 * where `undefined` is the correct result - so the model's own error flag is the only reliable
 * signal, not the shape of what came back.
 */
export const succeeded = (asyncModel, resp) => !(asyncModel !== null && asyncModel !== void 0 && asyncModel.isError) && (resp === null || resp === void 0 ? void 0 : resp.isSuccessful) !== false;

/**
 * Whether a payload-returning lookup actually produced an answer.
 *
 * `run()` cancels the request already in flight when it is called again, and `auto()` skips
 * `failed()` for a cancel - so a superseded run resolves `undefined` with `isError` still false.
 * A caller that classifies on `isError` alone therefore reads a cancelled run as "succeeded, and
 * the answer is nothing", which renders as an empty grid, "No portal credentials saved", or
 * "not on this plan" at a paying customer.
 *
 * For a call that returns data, `undefined` can only mean "no answer" - never "the answer is
 * nothing" - so it must leave the surface neutral rather than negative. That is a different
 * question from `succeeded()`, which is for void endpoints where `undefined` IS the success shape
 * and the model's flag is the only signal available.
 */
export const answered = resp => resp !== undefined;